import React from "react";

import { useError, useStep } from "../../hooks";

import { CommonShirtImage, UploadOptions } from "../decorate";
import { CustomEditor } from "../editor";
import DeviceUpload from "../upload";

const HEADER = ["Upload/Select Logo", "Edit Logo", "Edit Logo Background"];

export default function ImageSelectionList(props) {
  const { deviceStep } = useStep();
  const { clearError } = useError();
  const components = {
    text: (
      <>
        <CustomEditor
          setUrl={(url) => {
            props?.removeBackground(url, (transparent, croppedTransparent) => {
              props?.getTexture(croppedTransparent);
            });
          }}
        />
      </>
    ),
    device: <DeviceUpload {...props} />,
    gallery: <DeviceUpload {...{ isGallery: true, ...props }} />,
  };

  return (
    <div>
      <div className="row">
        <div className="col-sm-12 text-center mb-4">
          <div className="logo-place">
            <h2>{HEADER?.[deviceStep] || "Upload/Select Logo"}</h2>
          </div>
        </div>
        <div className="col-lg-7">
          <CommonShirtImage />
        </div>
        <div className="col-lg-5">
          {props?.selected === null ? (
            <UploadOptions
              setSelected={(val) => {
                props?.setSelected(val);
                clearError();
              }}
            />
          ) : (
            <div className="mt-3">{components?.[props?.selected]}</div>
          )}
        </div>
      </div>
    </div>
  );
}
